import { render, staticRenderFns } from "./PageUserProfile.vue?vue&type=template&id=9a854c68&"
import script from "./PageUserProfile.vue?vue&type=script&lang=js&"
export * from "./PageUserProfile.vue?vue&type=script&lang=js&"
import style0 from "./PageUserProfile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports